
import axios from '@/app/shared/config/interceptor'

const PREFIX = 'dahboard-tv/due-date-by-boards'

export default {
  getDuedate (boardId) {
    return axios.get(`${PREFIX}/${boardId}`)
  }
}
